module.exports = __webpack_public_path__ + "static/media/paybotic_logo.023f928e.png";